import React from "react";
import PropTypes from "prop-types";
import { AUTO_APPROVAL_TYPES } from "@constants";
import { Modal, Tooltip } from "../../../../components";

import "./AgencyRulesModal.scss";

const AgencyRulesModal = props => {
	const { lang } = global;
	const { show, onHide, handleSave, rules, handleChange, isInternalCoordinator } = props;
	const {
		_hoursMultiplier,
		JobAutoAssignType,
		JobAutoAssignHoursSpan,
		JobAutoAssignJobCountDaysSpan,
		JobAutoAssignYearToDateSpan,
	} = rules;

	const {
		MANUAL,
		FIRST_COME_FIRST_SERVED,
		BY_HOURS,
		BY_JOBS,
		SENIORITY_DESCENDING,
		SENIORITY_ASCENDING,
		RANDOM,
	} = AUTO_APPROVAL_TYPES;

	return (
		<Modal
			show={show}
			onHide={() => onHide()}
			id="agency-assignment-rules-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Agency Assignment Rules")}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="container-fluid">
				<div className="row">
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="auto-assign-manual">
								<input
									type="radio"
									name="auto-assign-type"
									id="auto-assign-manual"
									disabled={isInternalCoordinator}
									onChange={() => handleChange("JobAutoAssignType", MANUAL)}
									checked={JobAutoAssignType === MANUAL}
								/>
								{lang.t("Assign Manually")}
								<Tooltip
									content={`${lang.t("Officers can apply for the job, and will be shown to you in a list_")}
												   ${lang.t("You will then have to manually select the officer you wish to assign to the job_")}`}
								>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="based-on-fcfs">
								<input
									type="radio"
									name="auto-assign-type"
									id="based-on-fcfs"
									disabled={isInternalCoordinator}
									onChange={() =>
										handleChange("JobAutoAssignType", FIRST_COME_FIRST_SERVED)
									}
									checked={JobAutoAssignType === FIRST_COME_FIRST_SERVED}
								/>
								{lang.t("Based on first-come first-serve rule")}
								<Tooltip
									content={lang.t(
										"The first officer to apply for the job will be accepted_",
									)}
								>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="by-hours">
								<input
									type="radio"
									name="auto-assign-type"
									id="by-hours"
									disabled={isInternalCoordinator}
									onChange={() => handleChange("JobAutoAssignType", BY_HOURS)}
									checked={JobAutoAssignType === BY_HOURS}
								/>
								{lang.t("By hours")}
								<Tooltip
									content={lang.t(
										"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of hours_",
									)}
								>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<If condition={JobAutoAssignType === BY_HOURS}>
						<div className="row subrow">
							<div className="col-xs-4 col-sm-3 col-xs-offset-1">{`${lang.t("Sign-Up Period")}:`}</div>
							<div className="col-xs-2 form-group">
								<input
									type="number"
									min="0"
									id="assign-hours-span"
									name="assign-hours-span"
									className="form-control"
									placeholder="0"
									disabled={isInternalCoordinator}
									value={JobAutoAssignHoursSpan}
									onChange={({ target: { value } }) =>
										handleChange("JobAutoAssignHoursSpan", value)
									}
								/>
							</div>
							<div className="col-xs-4 col-sm-2 form-group">
								<select
									id="assign-hours-multiplier"
									name="assign-hours-multiplier"
									className="form-control"
									value={_hoursMultiplier}
									disabled={isInternalCoordinator}
									onChange={({ target: { value } }) =>
										handleChange("_hoursMultiplier", value)
									}
								>
									<option value="1">{lang.t("Hours")}</option>
									<option value="24">{lang.t("Days")}</option>
								</select>
							</div>
						</div>
						<div className="row subrow">
							<div className="col-xs-11 col-xs-offset-1 space-below">{`${lang.t("Time to Consider")}:`}</div>
							<div className="col-xs-2 col-xs-offset-2">
								<div className="radio">
									<label htmlFor="assign-days">
										<input
											type="radio"
											name="assign-time"
											id="assign-days"
											disabled={isInternalCoordinator}
											onChange={() =>
												handleChange("JobAutoAssignYearToDateSpan", "")
											}
											checked={JobAutoAssignYearToDateSpan === ""}
										/>
										{`${lang.t("Days")}:`}
									</label>
								</div>
							</div>
							<div className="col-xs-2 form-group">
								<label htmlFor="assign-days">
									<input
										type="number"
										min="0"
										id="assign-days-span"
										name="assign-days-span"
										className="form-control"
										placeholder="0"
										value={JobAutoAssignJobCountDaysSpan}
										disabled={
											JobAutoAssignYearToDateSpan !== "" ||
											isInternalCoordinator
										}
										onChange={({ target: { value } }) =>
											handleChange("JobAutoAssignJobCountDaysSpan", value)
										}
									/>
								</label>
							</div>
							<div className="col-xs-6" />
							<div className="col-xs-10 col-xs-offset-2">
								<div className="radio">
									<label htmlFor="assign-ytd">
										<input
											type="radio"
											name="assign-time"
											id="assign-ytd"
											disabled={isInternalCoordinator}
											onChange={() =>
												handleChange("JobAutoAssignYearToDateSpan", "true")
											}
											checked={JobAutoAssignYearToDateSpan !== ""}
										/>
										{lang.t("Year to Date")}
									</label>
								</div>
							</div>
						</div>
					</If>
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="by-number-of-jobs">
								<input
									type="radio"
									name="auto-assign-type"
									id="by-number-of-jobs"
									disabled={isInternalCoordinator}
									onChange={() => handleChange("JobAutoAssignType", BY_JOBS)}
									checked={JobAutoAssignType === BY_JOBS}
								/>
								{lang.t("By number of jobs")}
								<Tooltip
									content={lang.t(
										"Officers can apply for the job, which will then be automatically assigned to the officer with the fewest number of jobs_",
									)}
								>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<If condition={JobAutoAssignType === BY_JOBS}>
						<div className="row subrow">
							<div className="col-xs-4 col-sm-3 col-xs-offset-1">{`${lang.t("Sign-Up Period")}:`}</div>
							<div className="col-xs-2 form-group">
								<input
									type="number"
									min="0"
									id="assign-hours-span"
									name="assign-hours-span"
									className="form-control"
									placeholder="0"
									disabled={isInternalCoordinator}
									value={JobAutoAssignHoursSpan}
									onChange={({ target: { value } }) =>
										handleChange("JobAutoAssignHoursSpan", value)
									}
								/>
							</div>
							<div className="col-xs-4 col-sm-2 form-group">
								<select
									id="assign-hours-multiplier"
									name="assign-hours-multiplier"
									className="form-control"
									value={_hoursMultiplier}
									disabled={isInternalCoordinator}
									onChange={({ target: { value } }) =>
										handleChange("_hoursMultiplier", value)
									}
								>
									<option value="1">{lang.t("Hours")}</option>
									<option value="24">{lang.t("Days")}</option>
								</select>
							</div>
						</div>
						<div className="row subrow">
							<div className="col-xs-11 col-xs-offset-1 space-below">{`${lang.t("Time to Consider")}:`}</div>
							<div className="col-xs-2 col-xs-offset-2">
								<div className="radio">
									<label htmlFor="assign-days">
										<input
											type="radio"
											name="assign-time"
											id="assign-days"
											disabled={isInternalCoordinator}
											onChange={() =>
												handleChange("JobAutoAssignYearToDateSpan", "")
											}
											checked={JobAutoAssignYearToDateSpan === ""}
										/>
										{`${lang.t("Days")}:`}
									</label>
								</div>
							</div>
							<div className="col-xs-2 form-group">
								<label htmlFor="assign-days">
									<input
										type="number"
										min="0"
										id="assign-days-span"
										name="assign-days-span"
										className="form-control"
										placeholder="0"
										value={JobAutoAssignJobCountDaysSpan}
										disabled={
											JobAutoAssignYearToDateSpan !== "" ||
											isInternalCoordinator
										}
										onChange={({ target: { value } }) =>
											handleChange("JobAutoAssignJobCountDaysSpan", value)
										}
									/>
								</label>
							</div>
							<div className="col-xs-6" />
							<div className="col-xs-10 col-xs-offset-2">
								<div className="radio">
									<label htmlFor="assign-ytd">
										<input
											type="radio"
											name="assign-time"
											id="assign-ytd"
											disabled={isInternalCoordinator}
											onChange={() =>
												handleChange("JobAutoAssignYearToDateSpan", "true")
											}
											checked={JobAutoAssignYearToDateSpan !== ""}
										/>
										{lang.t("Year to Date")}
									</label>
								</div>
							</div>
						</div>
					</If>
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="auto-assign-desc">
								<input
									type="radio"
									name="auto-assign-type"
									id="auto-assign-desc"
									disabled={isInternalCoordinator}
									onChange={() =>
										handleChange("JobAutoAssignType", SENIORITY_DESCENDING)
									}
									checked={JobAutoAssignType === SENIORITY_DESCENDING}
								/>
								{lang.t("By Seniority (Descending)")}
								<Tooltip content={lang.t("Most senior officers first")}>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<If condition={JobAutoAssignType === SENIORITY_DESCENDING}>
						<div className="row subrow">
							<div className="col-xs-4 col-sm-3 col-xs-offset-1">{`${lang.t("Sign-Up Period")}:`}</div>
							<div className="col-xs-2 form-group">
								<input
									type="number"
									min="0"
									id="assign-hours-span"
									name="assign-hours-span"
									className="form-control"
									placeholder="0"
									disabled={isInternalCoordinator}
									value={JobAutoAssignHoursSpan}
									onChange={({ target: { value } }) =>
										handleChange("JobAutoAssignHoursSpan", value)
									}
								/>
							</div>
							<div className="col-xs-4 col-sm-2 form-group">
								<select
									id="assign-hours-multiplier"
									name="assign-hours-multiplier"
									className="form-control"
									value={_hoursMultiplier}
									disabled={isInternalCoordinator}
									onChange={({ target: { value } }) =>
										handleChange("_hoursMultiplier", value)
									}
								>
									<option value="1">{lang.t("Hours")}</option>
									<option value="24">{lang.t("Days")}</option>
								</select>
							</div>
						</div>
					</If>
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="auto-assign-asc">
								<input
									type="radio"
									name="auto-assign-type"
									id="auto-assign-asc"
									disabled={isInternalCoordinator}
									onChange={() =>
										handleChange("JobAutoAssignType", SENIORITY_ASCENDING)
									}
									checked={JobAutoAssignType === SENIORITY_ASCENDING}
								/>
								{lang.t("By Seniority (Ascending)")}
								<Tooltip
									content={lang.t("Officers with least number of years first")}
								>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<If condition={JobAutoAssignType === SENIORITY_ASCENDING}>
						<div className="row subrow">
							<div className="col-xs-4 col-sm-3 col-xs-offset-1">{`${lang.t("Sign-Up Period")}:`}</div>
							<div className="col-xs-2 form-group">
								<input
									type="number"
									min="0"
									id="assign-hours-span"
									name="assign-hours-span"
									className="form-control"
									placeholder="0"
									disabled={isInternalCoordinator}
									value={JobAutoAssignHoursSpan}
									onChange={({ target: { value } }) =>
										handleChange("JobAutoAssignHoursSpan", value)
									}
								/>
							</div>
							<div className="col-xs-4 col-sm-2 form-group">
								<select
									id="assign-hours-multiplier"
									name="assign-hours-multiplier"
									className="form-control"
									value={_hoursMultiplier}
									disabled={isInternalCoordinator}
									onChange={({ target: { value } }) =>
										handleChange("_hoursMultiplier", value)
									}
								>
									<option value="1">{lang.t("Hours")}</option>
									<option value="24">{lang.t("Days")}</option>
								</select>
							</div>
						</div>
					</If>
					<div className="col-xs-12">
						<div className="radio">
							<label htmlFor="auto-assign-random">
								<input
									type="radio"
									name="auto-assign-type"
									id="auto-assign-random"
									disabled={isInternalCoordinator}
									onChange={() => handleChange("JobAutoAssignType", RANDOM)}
									checked={JobAutoAssignType === RANDOM}
								/>
								{lang.t("Randomly")}
								<Tooltip
									content={lang.t(
										"Officers will be assigned randomly after the signup period is closed",
									)}
								>
									<i className="rkf rkf-question-solid margin-left-5 tooltip-icon" />
								</Tooltip>
							</label>
						</div>
					</div>
					<If condition={JobAutoAssignType === RANDOM}>
						<div className="row subrow">
							<div className="col-xs-4 col-sm-3 col-xs-offset-1">{`${lang.t("Sign-Up Period")}:`}</div>
							<div className="col-xs-2 form-group">
								<input
									type="number"
									min="0"
									id="assign-hours-span"
									name="assign-hours-span"
									className="form-control"
									placeholder="0"
									disabled={isInternalCoordinator}
									value={JobAutoAssignHoursSpan}
									onChange={({ target: { value } }) =>
										handleChange("JobAutoAssignHoursSpan", value)
									}
								/>
							</div>
							<div className="col-xs-4 col-sm-2 form-group">
								<select
									id="assign-hours-multiplier"
									name="assign-hours-multiplier"
									className="form-control"
									value={_hoursMultiplier}
									disabled={isInternalCoordinator}
									onChange={({ target: { value } }) =>
										handleChange("_hoursMultiplier", value)
									}
								>
									<option value="1">{lang.t("Hours")}</option>
									<option value="24">{lang.t("Days")}</option>
								</select>
							</div>
						</div>
					</If>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-link"
					onClick={() => onHide()}
				>
					{lang.t(isInternalCoordinator ? "Close" : "Cancel")}
				</button>
				<If condition={!isInternalCoordinator}>
					<button
						type="button"
						className="btn btn-primary"
						onClick={() => handleSave()}
					>
						{lang.t("Save")}
					</button>
				</If>
			</Modal.Footer>
		</Modal>
	);
};

AgencyRulesModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	handleSave: PropTypes.func,
	rules: PropTypes.object,
	handleChange: PropTypes.func,
	isInternalCoordinator: PropTypes.bool,
};

AgencyRulesModal.defaultProps = {
	show: false,
	onHide: () => {},
	handleSave: () => {},
	rules: {},
	handleChange: () => {},
	isInternalCoordinator: false,
};

export default AgencyRulesModal;
